import { defineStore } from 'pinia';
import {ref} from 'vue';

export const useActivityStore = defineStore('activity', () => {
    const selectedDateStart = ref("");
    const selectedDateEnd = ref("");
    const step = ref(0)
    const selectedCurrency = ref("CHF");
    const selectedPriceGroup = ref(null);
    const allPriceGroups = ref([]);
    const stepValidation = ref({});

    /*priceGroups for calendar view*/
    /*priceGroupsPerDate for date-list view*/
    /*priceGroupsPerDateTime for time-list view*/
    const ticketConfigurations = ref({
        priceGroups: {},
        priceGroupsPerDate: {},
        priceGroupsPerDateTime: {},
        configurations: [],
        finalPrice: 0,
    });

    function changeStep(value) {
        step.value = value;
    }

    function changeDateStart(value) {
        selectedDateStart.value = value;
    }

    function changeDateEnd(value) {
        selectedDateEnd.value = value;
    }

    function changeCurrency(value) {
        selectedCurrency.value = value;
    }

    function changePriceGroup(value) {
        selectedPriceGroup.value = value;
    }

    function changeFinalPrice(value) {
        ticketConfigurations.value.finalPrice = value;
    }

    function changeAllPriceGroups(value) {
        allPriceGroups.value = value;
    }

    function changeTicketConfigurations(value) {
        ticketConfigurations.value = value;
    }

    function changeConfigurations(value) {
        ticketConfigurations.value.configurations = value;
    }

    function changeStepValidation(value) {
        stepValidation.value = value;
    }

    function resetServiceStep() {
        changeTicketConfigurations({
            priceGroups: {},
            priceGroupsPerDate: {},
            priceGroupsPerDateTime: {},
            configurations: [],
            finalPrice: 0,
        })
    }

    function resetAll() {
        changeDateStart("");
        changeDateEnd("");
        changeStep(0);
        changePriceGroup(null);
        changeFinalPrice(0);
        changeStepValidation({});
        changeAllPriceGroups([]);
        changeTicketConfigurations({
            priceGroups: {},
            priceGroupsPerDate: {},
            priceGroupsPerDateTime: {},
            configurations: [],
            finalPrice: 0,
        })
    }

    return {
        changeDateStart,
        selectedDateStart,
        selectedDateEnd,
        changeDateEnd,
        changeStep,
        selectedCurrency,
        changeCurrency,
        changePriceGroup,
        selectedPriceGroup,
        allPriceGroups,
        changeAllPriceGroups,
        ticketConfigurations,
        changeTicketConfigurations,
        stepValidation,
        changeStepValidation,
        changeConfigurations,
        changeFinalPrice,
        resetServiceStep,
        resetAll,
        step
    }
})